<script>
import { Line, mixins } from 'vue-chartjs'
import 'Chart.Bands.js/src/chart.bands.js'

export default {
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: ['upperBound', 'lowerBound', 'chartData', 'options'],
  data() {
    return {
      defaultData: {
      },
      defaultOptions: {
        maintainAspectRatio: false,
        responsive: true,
        layout: {
          padding: { top: 40 }
        },
        legend: {
          position: 'bottom',
          labels: {
            filter: (item, data) => {
              return !data.datasets[item.datasetIndex].noLegend
            }
          }
        },
        scales: {
          yAxes: [
            {
              display: false,
              ticks: { min: 0 }
            },
            {
              id: 'main',
              type: 'linear',
              position: 'left',
              ticks: { min: 0 }
            }
          ]
        },
        tooltips: {
          mode            : 'index',
          position        : 'nearest',
          intersect       : false,
          caretSize       : 2,
          displayColors   : false,
          backgroundColor : '#444',
          reverse         : true,
          bodyFontFamily  : 'monospace',
          itemSort(a,b) {
            return a.datasetIndex <= b.datasetIndex ? -1 : 1;
          },
          callbacks: {
            title: function(tooltipItems, data) {
              return tooltipItems[tooltipItems.length - 1].xLabel
            },
            label: function(tooltipItem, data) {
              let index = tooltipItem.datasetIndex
              let value = (data.datasets[index].preUnit || '')
              if (data.datasets[index].preUnit == '$')
                value += tooltipItem.yLabel.toFixed(2)
              else
                value += Math.round(tooltipItem.yLabel * 100) / 100
              value += (data.datasets[index].postUnit || '')

              return (data.datasets[index].label + ":          ").slice(0, 8) + ("            " + value).slice(-8)
            }
          }
        },
        hover: {
          mode                : 'index',
          intersect           : false,
          animationDuration   : 0
        },
        bands: {
          yValueMax: this.upperBound,
          yValueMin: this.lowerBound,
          belowMinThresholdColour: [
            'rgba(233,68,62,1)'
          ],
          aboveMaxThresholdColour: [
            'rgba(5,170,157,1)'
          ]
        }
      }
    }
  },
  computed: {
    fullData() {
      return Object.assign(this.defaultData, this.chartData)
    },
    fullOptions() {
      return Object.assign(this.defaultOptions, this.options)
    }
  },
  mounted() {
    this.render()
  },
  methods: {
    render() {
      this.renderChart(this.fullData, this.fullOptions)
    }
  }
}
</script>



// WEBPACK FOOTER //
// line-chart.vue?401b9a29